export default __webpack_public_path__ + "static/69-b2c78215324daa736e7a9255a139d724.jpg";